import { render, staticRenderFns } from "./SigleSourceRelAutocomplete.vue?vue&type=template&id=22043169&"
import script from "./SigleSourceRelAutocomplete.vue?vue&type=script&lang=js&"
export * from "./SigleSourceRelAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports